module.exports = __webpack_public_path__ + "static/media/my_plans_selected.66dd4d61.svg";